import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { FormModalProvider } from './context/FormModalContext';
import Layout from './components/Layout';
import ApplicationFormModal from './components/ApplicationFormModal';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactsPage from './pages/ContactsPage';
import RequisitesPage from './pages/RequisitesPage';
import VacanciesPage from './pages/VacanciesPage';
import ConditionsPage from './pages/ConditionsPage';
import FaqPage from './pages/FaqPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

const App = () => (
    <FormModalProvider>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<HomePage />} />
                    <Route path="about" element={<AboutPage />} />
                    <Route path="contacts" element={<ContactsPage />} />
                    <Route path="requisites" element={<RequisitesPage />} />
                    <Route path="vacancies" element={<VacanciesPage />} />
                    <Route path="conditions" element={<ConditionsPage />} />
                    <Route path="faq" element={<FaqPage />} />
                    <Route path="privacy" element={<PrivacyPage />} />
                    <Route path="terms" element={<TermsPage />} />
                </Route>
            </Routes>
            <ApplicationFormModal />
        </BrowserRouter>
    </FormModalProvider>
);

export default App;
